import { render, staticRenderFns } from "./BaseSwitch.vue?vue&type=template&id=72e00a4e"
import script from "./BaseSwitch.vue?vue&type=script&lang=ts"
export * from "./BaseSwitch.vue?vue&type=script&lang=ts"
import style0 from "./BaseSwitch.vue?vue&type=style&index=0&id=72e00a4e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports